import { render, staticRenderFns } from "./Workloads.vue?vue&type=template&id=7ab47d07"
import script from "./Workloads.vue?vue&type=script&lang=js"
export * from "./Workloads.vue?vue&type=script&lang=js"
import style0 from "./Workloads.vue?vue&type=style&index=0&id=7ab47d07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports